module.exports = __webpack_public_path__ + "img/能力建设类.09302b37.png";